
















































































































































































































































import { Component, mixins } from 'nuxt-property-decorator'
import BaseModal from '../../components/modals/BaseModal.vue'
import { UserMixin } from '~/node_modules/sitis-nuxt/lib/mixins'

@Component({
  components: {
    BaseModal
  }
})
export default class RequestPasswordModal extends mixins(UserMixin) {
  phoneNumber = '';
  $modal: any;
  $auth: any;

  get submitIsDisabled (): boolean {
    return !this.phoneNumber
  }

  onBeforeOpen ({ params }: { params?: { phoneNumber: string } }): void {
    this.phoneNumber = (params && params?.phoneNumber) || ''
  }

  async submitForm (): Promise<void> {
    if (!this.submitIsDisabled) {
      await this.requestPassword(this.phoneNumber)
      this.$modal.show('login-modal', {
        phoneNumber: this.phoneNumber
      })
      this.$modal.hide('request-password-modal')
    }
  }
}
